const customer_exit_messages = {
  title: ['customer_exit>>title', 'Customer exit'],
  description: ['customer_exit>>description', 'Search for a customer, review export scope and create a logged data exit package.'],
  search_label: ['customer_exit>>search_label', 'Search customer'],
  search_button: ['customer_exit>>search_button', 'Search'],
  create_export: ['customer_exit>>create_export', 'Create exit package'],
  end_customer: ['customer_exit>>end_customer', 'End Customer'],
  customer_details: ['customer_exit>>customer_details', 'Customer details'],
  activity_log: ['customer_exit>>activity_log', 'Exit activity log'],
  no_customer_selected: ['customer_exit>>no_customer_selected', 'Search and select a customer to view exit details.'],
  organization: ['customer_exit>>organization', 'Organization'],
  organization_number: ['customer_exit>>organization_number', 'Registration number'],
  status: ['customer_exit>>status', 'Status'],
  created: ['customer_exit>>created', 'Created'],
  contact_name: ['customer_exit>>contact_name', 'Contact name'],
  contact_email: ['customer_exit>>contact_email', 'Contact email'],
  action_templates: ['customer_exit>>action_templates', 'Action templates'],
  asset_action_instances: ['customer_exit>>asset_action_instances', 'Asset action instances'],
  incidents: ['customer_exit>>incidents', 'Incidents'],
  dsar_cases: ['customer_exit>>dsar_cases', 'DSAR cases'],
  dsar_asset_cases: ['customer_exit>>dsar_asset_cases', 'DSAR asset cases'],
  assets: ['customer_exit>>assets', 'Assets'],
  employees: ['customer_exit>>employees', 'Employees'],
  export_dialog_title: ['customer_exit>>export_dialog_title', 'Create exit package'],
  export_dialog_text: [
    'customer_exit>>export_dialog_text',
    'Add the mandatory reason or ticket reference before creating the ZIP package.',
  ],
  comment: ['customer_exit>>comment', 'Comment'],
  cancel: ['customer_exit>>cancel', 'Cancel'],
  confirm: ['customer_exit>>confirm', 'Create and download'],
  action: ['customer_exit>>action', 'Action'],
  performed_by: ['customer_exit>>performed_by', 'Performed by'],
  query: ['customer_exit>>query', 'Query'],
  export_id: ['customer_exit>>export_id', 'Export ID'],
  timestamp: ['customer_exit>>timestamp', 'Timestamp'],
  export_created: ['customer_exit>>export_created', 'Exit package created.'],
  customer_terminated: ['customer_exit>>customer_terminated', 'Customer terminated.'],
  terminate_error: ['customer_exit>>terminate_error', 'The customer could not be terminated.'],
  comment_required: ['customer_exit>>comment_required', 'Enter a comment or termination reason.'],
  comment_too_long: ['customer_exit>>comment_too_long', 'The comment must be 1000 characters or fewer.'],
  terminate_dialog_title: ['customer_exit>>terminate_dialog_title', 'End Customer'],
  terminate_dialog_text_1: [
    'customer_exit>>terminate_dialog_text_1',
    "You are about to terminate {{customer}} and the customer's PocketSafe subscription.",
  ],
  terminate_dialog_text_2: [
    'customer_exit>>terminate_dialog_text_2',
    'This is a destructive action and must only be performed when the customer termination has been approved and any required exit package has been created and handled.',
  ],
  terminate_dialog_text_3: [
    'customer_exit>>terminate_dialog_text_3',
    'The action has the same consequences as when the customer selects "Terminate organization" from the organization administration page.',
  ],
  terminate_dialog_text_4: ['customer_exit>>terminate_dialog_text_4', 'Are you sure you want to continue?'],
  terminate_comment_label: ['customer_exit>>terminate_comment_label', 'Comment or termination reason'],
};

export default customer_exit_messages;
